
<kendo-dialog-titlebar>
    <span > {{'admin-center.header.editPeriodicalValue' | translate}}</span>
</kendo-dialog-titlebar>



<div fxLayout="column"   class="form-block"  *ngIf="periodicalValues$ | async;let periodicalValues ">
  
    <strong *ngIf="periodicalValues.length == 0">
        {{'admin-center.common.noPeriodicalValues' | translate}}  
    </strong>

    <div *ngIf="periodicalValues.length > 0">
        <div fxFlex.lt-md="100" *ngFor="let periodicalValue of periodicalValues;last as isLast" fxLayoutGap="5px">

            <strong *ngIf="periodicalValue.calculationTypeId == 1">
                {{periodicalValue.value | percent : '1.2-2' }} 
            </strong>
    
            <strong *ngIf="periodicalValue.calculationTypeId == 2">
                {{periodicalValue.value | number : '1.2-2' }} 
            </strong>
    
            <span>
                {{'admin-center.common.periodicalValueFromDate' | translate}}  
                {{periodicalValue.fromDate | date:'yyyy-MM-dd' }} 
                {{'admin-center.common.periodicalValueToDate' | translate}}  
                {{periodicalValue.toDate | date:'yyyy-MM-dd' }} 
            </span>

            <kendo-icon *ngIf="isLast"  name="delete" [themeColor]="'error'" (click)="removeLastValue()"></kendo-icon>
           
        </div>
      
    </div>
   

    <button *ngIf="!addNewFormShown"  type="button" kendoButton (click)="showAddNewForm()"  icon="plus">
        {{'admin-center.common.addPeriodicalValue' | translate}}  
    </button>
    <div  *ngIf="addNewFormShown && addNewValueForm" class="form-block">

        <form [formGroup]="addNewValueForm">
            <div fxLayout="column" fxLayoutAlign="center center">
                <div>
                    <date-input-ctrl [caption]="'admin-center.common.periodicalValueFromDate'"
                        [formControlName]="'fromDate'" [settings]="{fxFill:true}">
                    </date-input-ctrl>

                    <static-dictionary-select-ctrl [caption]="'admin-center.common.calculationType'"
                        [formControlName]="'calculationTypeId'" [staticDictionaryName]="'provisionCalculationType'"
                        [settings]="{fxFill:true}"  (valueChangeEvent)="calculationTypeChanged($event)">
                    </static-dictionary-select-ctrl>

                    <div *ngIf="newRecordCalculationType == 1">
                        <numeric-input-ctrl [caption]="'admin-center.common.periodicalValue'"
                            [formControlName]="'value'" [settings]="{format:'p2',step:0.01,fxFill:true}">
                        </numeric-input-ctrl>
                    </div>

                    <div *ngIf="newRecordCalculationType == 2">
                        <numeric-input-ctrl [caption]="'admin-center.common.periodicalValue'"
                            [formControlName]="'value'" [settings]="{format:'n',step:1,fxFill:true}">
                        </numeric-input-ctrl>
                    </div>
                   
                </div>
        
                <div fxLayoutAlign="space-between center" fxLayoutGap="10px">
                    <button type="button" kendoButton (click)="confirmAddNew()"> {{'global.confirm' | translate}}  </button>
                    <button type="button" kendoButton (click)="hideAddNewForm()">{{'global.cancel' | translate}}   </button>
                  
                </div>
            </div>
        </form>
        
    </div>
</div>

<kendo-dialog-actions>
    <button kendoButton (click)="close()" [primary]="true" submit>
        <span>{{'global.close' | translate}}</span>
    </button>
</kendo-dialog-actions> 

<div kendoDialogContainer #changePeriodicalValueDialog></div>